import { Map } from 'immutable';

import * as t from '../actions/notificationMessageActionTypes';

const initialState = Map({
  notificationsUnread: [],
  notificationsSeen: [],
  loadNotification: false,
});

const reducer = function mainNotificationMessageReducer(
  state = initialState,
  action,
) {
  switch (action.type) {
    case t.SET_NOTIFICATIONS_MESSAGE_UNREAD:
      return state.set('notificationsUnread', action.notifications);
    case t.SET_NOTIFICATIONS_MESSAGE_SEEN:
      return state.set('notificationsSeen', action.notifications);
    case t.LOAD_NOTIFICATIONS:
      return state.set('loadNotification', action.value);
    default:
      return state;
  }
};

export default reducer;
